import {
  Car,
  Phone,
  Mail,
  MapPin,
  Facebook,
  Instagram,
} from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Footer.css";

export default function Footer() {
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  const PHONE_NUMBER = "+351 915 129 868";
  const PHONE_LINK = "tel:+351915129868";

  const EMAIL = "book.tripalgarve@gmail.com";
  const EMAIL_LINK = `mailto:${EMAIL}`;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand-block">
          <div className="footer-brand">
            <div className="brand-icon">
              <Car size={26} />
            </div>

            <div>
              <span className="brand-name">Francesco</span>

              <span className="brand-sub">
                {t("footer.brandSubtitle")}
              </span>
            </div>
          </div>

          <p className="brand-desc">
            {t("footer.description")}
          </p>

          <div className="socials">
  <a
    href="https://www.facebook.com/profile.php?id=100063527860394"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Facebook"
  >
    <Facebook size={18} />
  </a>

  <a
    href="https://www.instagram.com/francesco_airport_transfers"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram"
  >
    <Instagram size={18} />
  </a>
</div>
        </div>

        <div className="footer-links">
          <h3>{t("footer.navigation.title")}</h3>

          <Link to="/">
            {t("footer.navigation.home")}
          </Link>

          <Link to="/prices">
            {t("footer.navigation.prices")}
          </Link>

          <Link to="/about">
            {t("footer.navigation.about")}
          </Link>

          <Link to="/contacts">
            {t("footer.navigation.contacts")}
          </Link>
        </div>

        <div className="footer-contact">
          <h3>{t("footer.contacts.title")}</h3>

          <a href={PHONE_LINK} className="contact-line">
            <Phone size={17} />
            <span>{PHONE_NUMBER}</span>
          </a>

          <a href={EMAIL_LINK} className="contact-line">
            <Mail size={17} />
            <span>{EMAIL}</span>
          </a>

          <div className="contact-line">
            <MapPin size={17} />
            <span>{t("footer.contacts.location")}</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>
          {t("footer.copyright", {
            year: currentYear,
          })}
        </span>

        <div className="legal-links">
          <Link to="/terms">
            {t("footer.legal.terms")}
          </Link>

          <Link to="/privacy">
            {t("footer.legal.privacy")}
          </Link>

          <Link to="/cookies">
            {t("footer.legal.cookies")}
          </Link>
        </div>
      </div>
    </footer>
  );
}